;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _slimSelect = require("slim-select");

var _slimSelect2 = _interopRequireDefault(_slimSelect);

require("minibarjs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    name: {
      required: true,
      type: String
    },
    placeholder: String,
    multiple: Boolean,
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      default: null
    },
    onChange: Function
  },
  data: function data() {
    return {
      select: null,
      scrollbar: null,
      stopChangePropagation: false
    };
  },
  watch: {
    value: function value(_value) {
      if (!_value) {
        (0, _jquery2.default)(this.$refs.select).find("option").first().prop("selected", true);
      }

      this.reinit();
    },
    options: function options() {
      this.reinit();
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      this.select = new _slimSelect2.default({
        select: this.$refs.select,
        placeholder: this.placeholder,
        showSearch: false,
        allowDeselect: true,
        beforeOnChange: function beforeOnChange() {
          if (!_this.multiple) {
            var singleSelected = _this.select.slim.singleSelected;

            var $placeholder = (0, _jquery2.default)(singleSelected.placeholder);

            $placeholder.css("opacity", 0);
          }
        },
        onChange: function onChange(info) {
          if (_this.scrollbar) {
            _this.scrollbar = null;
          }

          _this.$nextTick(function () {
            if (!_this.multiple) {
              var singleSelected = _this.select.slim.singleSelected;

              var $placeholder = (0, _jquery2.default)(singleSelected.placeholder);

              if (info.text) {
                $placeholder.html("<i>" + _this.placeholder + "</i>: " + info.text);
              }

              $placeholder.css("opacity", 1);
            }

            if (!_this.stopChangePropagation) {
              var value = _this.getValues();

              _this.$emit("input", value);
              _this.onChange({
                name: _this.name,
                value: value
              });
            }
          });
        }
      });

      if (this.options.length) {
        this.select.enable();
      } else {
        this.select.disable();
      }

      if (this.value) {
        this.stopChangePropagation = true;
        this.select.set(this.value);
        this.$nextTick(function () {
          _this.stopChangePropagation = false;
        });
      }
    },
    destroy: function destroy() {
      this.select.destroy();
    },
    reinit: function reinit() {
      this.destroy();
      this.init();
    },
    getValues: function getValues() {
      var select = this.$refs.select;
      var options = (0, _from2.default)(select.selectedOptions);
      var values = options.map(function (option) {
        return option.value;
      });

      return this.multiple ? values : values[0];
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"select",staticClass:"ss-select",attrs:{"name":_vm.name,"multiple":_vm.multiple},domProps:{"value":_vm.value}},[(_vm.placeholder)?_c('option',{attrs:{"data-placeholder":"true"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label)+"\n  ")])})],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32a38830", __vue__options__)
  } else {
    hotAPI.reload("data-v-32a38830", __vue__options__)
  }
})()}